<template>
	<auth-layout
		title="亚太互联"
		subtitle="连接亚太，协作无界"
		form-title="注册-Create account"
		form-subtitle="填写以下信息完成注册"
		wide
		:features="registerFeatures"
	>
		<el-form
			:model="dataForm"
			status-icon
			:rules="rules"
			ref="registerForm"
			label-width="80px"
			class="auth-form"
			@keyup.enter.native="submitForm()"
		>
			<el-form-item v-if="dataForm.mode == 'phone'" label="手机号码" prop="phone">
				<el-input
					v-model="dataForm.phone"
					autocomplete="off"
					placeholder="请输入手机号码"
					maxLength="11"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item v-if="dataForm.mode == 'email'" label="邮箱" prop="email">
				<el-input v-model="dataForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
			</el-form-item>
			<el-form-item v-show="dataForm.mode == 'email'" label="验证码" prop="code">
				<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
					<div v-if="emailLockTime > 0" slot="append">{{ `${emailLockTime}秒后重新获取` }}</div>
					<el-button v-else slot="append" class="auth-captcha-btn" @click="onLoadMailCaptcha">获取验证码</el-button>
				</el-input>
			</el-form-item>
			<el-form-item label="昵称" prop="nickName">
				<el-input
					type="nickName"
					v-model="dataForm.nickName"
					autocomplete="off"
					placeholder="请输入昵称"
					maxLength="50"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password">
				<el-input
					type="password"
					v-model="dataForm.password"
					autocomplete="off"
					placeholder="请输入密码"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="confirmPassword">
				<el-input
					type="password"
					v-model="dataForm.confirmPassword"
					autocomplete="off"
					placeholder="请再次输入密码"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="verifyCode">
				<div class="auth-captcha-row">
					<el-input
						v-model="dataForm.verifyCode"
						autocomplete="off"
						placeholder="请输入图形验证码"
						maxlength="6"
						clearable
						class="auth-captcha-row__input"
					></el-input>
					<div class="auth-captcha-row__img" @click="loadCaptchaImage" title="点击刷新">
						<img v-if="captchaImage" :src="captchaImage" class="auth-captcha-row__img-el" alt="验证码" />
						<span v-else class="auth-captcha-row__loading">加载中...</span>
					</div>
				</div>
			</el-form-item>
			<el-form-item>
				<div class="auth-actions auth-actions--stack">
					<el-button type="primary" size="large" @click="submitForm()">注册</el-button>
					<el-button size="large" @click="resetForm()">重置</el-button>
				</div>
			</el-form-item>
		</el-form>
		<template #footer>
			<router-link to="/login" class="auth-link">已有账号？去登录</router-link>
		</template>
	</auth-layout>
</template>

<script>
import AuthLayout from '@/components/common/AuthLayout.vue';

export default {
	name: 'register',
	components: {
		AuthLayout
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			const regex = /^1[3-9]\d{9}$/;
			if (!regex.test(value)) {
				return callback(new Error('手机号格式错误'));
			}
			callback();
		};
		var checkEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入邮箱'));
			}
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			if (!regex.test(value)) {
				return callback(new Error('邮箱格式错误'));
			}
			callback();
		};
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value != this.dataForm.password) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};
		var checkVerifyCode = (rule, value, callback) => {
			if (!value || !value.trim()) {
				return callback(new Error('请输入图形验证码'));
			}
			callback();
		};
		return {
			registerFeatures: [
				'Enterprise-grade security',
				'Instant messaging & collaboration',
				'Available on Web & Mobile'
			],
			dataForm: {
				phone: '',
				email: '',
				code: '',
				mode: 'phone',
				userName: '',
				nickName: '',
				password: '',
				confirmPassword: '',
				uuid: '',
				verifyCode: '',
				terminal: this.$enums.TERMINAL_TYPE.WEB
			},
			captchaImage: '',
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				email: [{
					validator: checkEmail,
					trigger: 'blur'
				}],
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}],
				verifyCode: [{
					validator: checkVerifyCode,
					trigger: 'blur'
				}]
			},
			showCaptchaImage: false,
			phoneLockTime: 0,
			phoneLockTimer: null,
			emailLockTime: 0,
			emailLockTimer: null,
			modeNameMap: {
				username: '用户名注册',
				phone: '手机号注册',
				email: '邮箱注册'
			}
		};
	},
	methods: {
		loadCaptchaImage() {
			this.$http({
				url: '/captcha/img/code',
				method: 'post'
			}).then((data) => {
				this.dataForm.uuid = data.id || data.uuid;
				this.captchaImage = data.image ? ('data:image/gif;base64,' + data.image) : '';
			}).catch(() => {
				this.$message.error('验证码加载失败');
			});
		},
		submitForm() {
			this.$refs.registerForm.validate((valid) => {
				if (valid) {
					this.$http({
						url: '/register',
						method: 'post',
						data: this.dataForm
					}).then(() => {
						this.$message.success('注册成功，去登录...');
						this.$router.push('/login');
					}).catch(() => {
						this.loadCaptchaImage();
						this.dataForm.verifyCode = '';
					});
				}
			});
		},
		setCookie(name, value) {
			document.cookie = name + '=' + escape(value);
		},
		onLoadSmsCaptcha() {
			this.$refs.registerForm.validateField('phone', (valid) => {
				if (valid == '') {
					this.$refs.captchaRef.open((id, code) => {
						this.phoneLockTime = 60;
						this.phoneLockTimer && clearInterval(this.phoneLockTimer);
						this.phoneLockTimer = setInterval(() => {
							this.phoneLockTime -= 1;
							if (this.phoneLockTime <= 0) {
								this.phoneLockTimer && clearInterval(this.phoneLockTimer);
							}
						}, 1000);
						let data = {
							phone: this.dataForm.phone,
							id: id,
							code: code
						};
						this.$http({
							url: '/captcha/sms/code',
							method: 'post',
							data: data
						}).then(() => {
							this.$message.success('验证码已发送至您的手机，请注意查收');
						});
					});
				}
			});
		},
		onLoadMailCaptcha() {
			this.$refs.registerForm.validateField('email', (valid) => {
				if (valid == '') {
					this.emailLockTime = 60;
					this.emailLockTimer && clearInterval(this.emailLockTimer);
					this.emailLockTimer = setInterval(() => {
						this.emailLockTime -= 1;
						if (this.emailLockTime <= 0) {
							this.emailLockTimer && clearInterval(this.emailLockTimer);
						}
					}, 1000);
					let data = {
						email: this.dataForm.email
					};
					this.$http({
						url: '/captcha/mail/code',
						method: 'post',
						data: data
					}).then(() => {
						this.$message.success('验证码已发送至您的邮箱，请注意查收');
					});
				}
			});
		},
		switchMode(mode) {
			this.dataForm.mode = mode;
			this.resetForm();
		},
		resetForm() {
			this.$refs.registerForm.resetFields();
			this.loadCaptchaImage();
		}
	},
	computed: {
		config() {
			return this.$store.state.configStore.registration;
		}
	},
	watch: {
		config: {
			handler() {
				this.switchMode(this.config.mode[0]);
			}
		}
	},
	mounted() {
		if (this.config.mode) {
			this.switchMode(this.config.mode[0]);
		}
		this.loadCaptchaImage();
	}
};
</script>
